import type {
  IArticleStructuredData,
  IEventStructuredData,
  IFAQStructuredData,
  IOrganizationStructuredData,
  ISoftwareAppStructuredData,
} from '@/interfaces';

export type SchemaMarkupItem =
  | IArticleStructuredData
  | IEventStructuredData
  | IOrganizationStructuredData
  | ISoftwareAppStructuredData
  | IFAQStructuredData;

const JSON_SPECIAL_CHAR_ESCAPES: Record<string, string> = {
  '<': '\\u003C',
  '>': '\\u003E',
  '&': '\\u0026',
  '\u2028': '\\u2028',
  '\u2029': '\\u2029',
};

const JSON_SPECIAL_CHARS_REGEX = /[<>&\u2028\u2029]/g;

// Escapes characters that could break out of a <script> tag or cause JS syntax errors
export const serializeSchemaForJsonLd = (schema: SchemaMarkupItem): string => {
  const json = JSON.stringify(schema);
  return json.replace(JSON_SPECIAL_CHARS_REGEX, (char) => JSON_SPECIAL_CHAR_ESCAPES[char] || char);
};
